module.exports = __webpack_public_path__ + "static/media/Chip.41599078.png";